export default "__VITE_ASSET__BJvJfFLi__"